import React from 'react';
import { Modal, Spinner } from "player-components";
import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchLibrarySongsAsync, selectLibrarySongs} from '../../features/library/librarySlice';
import {createSetlistFromData, selectSetlistsSetlists} from '../../features/setlists/setlistsSlice';
import { selectUser } from '../../features/auth/authSlice';
import { useCallback } from 'react';

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const CreateSetlistContainer = () => {
    const setlists = useSelector(selectSetlistsSetlists);
    const librarySongs = useSelector(selectLibrarySongs);
    const query = useQuery();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentUser = useSelector(selectUser);


    

    useEffect( async () => {
		// pgw 18-jul-2025
        console.log('CreateSetlistContainer mounted p1');
        const fetchedLibrarySongsRequest = await dispatch(fetchLibrarySongsAsync({startIndex: 0, limit: 600}));
        if (currentUser) {
        	console.log('CreateSetlistContainer mounted p2, currentUser = ', currentUser);
            if (!setlists.find(setlist => setlist.id === query.get('setlistId'))) {
                const itemsArray = query.get('items').split(',');
                console.log(itemsArray);
                console.log(fetchedLibrarySongsRequest.payload);
                await dispatch(createSetlistFromData({
                    setlistId: query.get('setlistId'),
                    title: query.get('title'),
                    subtitle: query.get('subtitle'),
                    imageUrl: atob(query.get('imageUrl')),
                    items: fetchedLibrarySongsRequest.payload.filter((song) => itemsArray.includes(song.songId)),
                    readOnly: true
                }));
            }
            navigate(`/setlist/${query.get('setlistId')}`, {replace: true});
        }
    }, []);

    return <div className="flex justify-center mt-4 mb-4">
        <Spinner />
        
    </div>
}

export default CreateSetlistContainer;